import {PayrollUpdatesPage} from './components';

export default PayrollUpdatesPage;
